import React from 'react';
import { Button, Paper, Text, Title } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Eyebrow } from './primitives';

export const DraftHint: React.FC<{ onOpenLast?: () => void; hasHistory: boolean }> = ({
  onOpenLast,
  hasHistory,
}) => {
  const { t } = useTranslation();
  return (
    <Paper withBorder p="xl" radius="md">
      <Eyebrow>{t('perfReview.home.draftHint.eyebrow')}</Eyebrow>
      <Title order={3} size="h4" mt={6} mb={8} style={{ letterSpacing: '-0.01em' }}>
        {t('perfReview.home.draftHint.title')}
      </Title>
      <Text c="dimmed" size="sm" lh={1.55} mb="md">
        {t('perfReview.home.draftHint.body')}
      </Text>
      {hasHistory && (
        <Button variant="default" rightSection={<IconArrowRight size={14} />} onClick={onOpenLast}>
          {t('perfReview.home.draftHint.openLast')}
        </Button>
      )}
    </Paper>
  );
};
